module.exports = __webpack_public_path__ + "static/media/dolly-flatbed-empty.1a59e73b.svg";